import device from '../helpers/device'
import refs from '../helpers/refs'
import videoUtil from '../helpers/video'

class CMastheadFeature {
  constructor (el) {
    this.hero = el
    this.$refs = refs(this.hero)

    this.init()
  }

  init () {
    // Different video sources for different screen sizes
    // Convert video data attributes to video sources
    // (If a video is even used on the masthead)
    if (this.$refs.video) {
      videoUtil.setVideoSources(this.$refs.video)
    }

    // Set hero to full height on mobile screens
    if (device.isMobile()) {
      this.hero.style.height = window.innerHeight - 131 + 'px'
    }
  }
}

// Masthead height won't be set correctly until the page has fully loaded
window.addEventListener('load', () => {
  document
    .querySelectorAll('[data-c-masthead-feature]')
    .forEach(el => new CMastheadFeature(el))
})
